import React from 'react';
import { NeroliOrchideeBestSellerModalProps } from '../../../interfaces/components';
import { NeroliOrchideeBestSellerModalContent } from '../../../content';
import useWindowDimensions from '../../../utils/hooks/useWindowDimensions';
import { Box, Image, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';
import { LoccitaneClose } from '../../../Icons/LoccitaneClose';
import NeroliOrchideeImage from '../../../assets/images/NeroliOrchidee2.jpeg';
import NeroliOrchideeLogo from '../../../assets/images/NeroliOrchideeLogo.png';
import NeroliDisplayProduct1Image from '../../../assets/images/NeroliDisplayProduct1.png';
import NeroliDisplayProduct2Image from '../../../assets/images/NeroliDisplayProduct2.webp';
import NeroliOrchideeProductItem from './NeroliOrchideeProductItem';

const NeroliOrchideeBestSellerModal = ({
  activeLocale,
  active,
  openProductPopUp,
  setActive,
}: NeroliOrchideeBestSellerModalProps) => {
  const { title, text, subTitle, product1, product2 } =
    NeroliOrchideeBestSellerModalContent[activeLocale as keyof typeof NeroliOrchideeBestSellerModalContent];

  const { width } = useWindowDimensions();

  const isDesktopScreen = width > 992;

  const onModalClose = () => {
    setActive(false);
  };

  return (
    <Modal onClose={onModalClose} isOpen={active}>
      <ModalOverlay />
      <ModalContent
        borderRadius="0px"
        m={['0px', '0px', 'auto', 'auto', 'auto']}
        h={['-webkit-fill-available', '-webkit-fill-available', '-webkit-fill-available', '500px', '550px']}
        maxW={['100%', '100%', '100%', 'fit-content', 'fit-content']}
        width={['100%', '100%', '100%', 'auto', 'auto']}
        overflowY={['auto', 'auto', 'auto', 'unset', 'unset']}
        overflowX="hidden"
        position="fixed"
        top="0"
        left="0"
        bottom="0"
        right="0"
      >
        <LoccitaneClose
          position="absolute"
          top={['15px', '15px', '30px', '30px', '30px']}
          right={['20px', '20px', '30px', '30px', '30px']}
          boxSize={[6, 6, 8]}
          cursor="pointer"
          strokeWidth={0.5}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
          onClick={onModalClose}
        />
        <ModalBody
          width={['100%', '100%', '100%', 'auto', 'auto']}
          height={['100%', '100%', '100%', '100%', '100%']}
          pointerEvents={active ? 'all' : 'none'}
          padding={['0px', '0px', '0px', '24px', '24px']}
        >
          <Box
            width={['auto', 'auto', 'auto', 'auto', 'auto']}
            height={['100%', '100%', '100%', '100%', '100%']}
            style={{ aspectRatio: isDesktopScreen ? '6.2/3.1' : 'unset' }}
            display="flex"
            justifyContent={['flex-start', 'flex-start', 'flex-start', 'space-between', 'space-between']}
            flexDirection={['column-reverse', 'column-reverse', 'column-reverse', 'row', 'row']}
            gap={isDesktopScreen ? '5' : '0'}
            outline={isDesktopScreen ? '4px solid #FFCB00' : 'none'}
          >
            <Box width={['100%', '100%', '100%', '65%', '65%']} textAlign="center">
              <Box
                width={'100%'}
                height={'100%'}
                bgImage={NeroliOrchideeImage}
                bgSize={'cover'}
                padding={['10px', '15px', '30px', '30px', '30px']}
              >
                <Box
                  width={'100%'}
                  height={'100%'}
                  bgColor={'rgba(255, 255, 255, 0.95)'}
                  padding={['15px', '20px', '20px', '25px', '25px']}
                >
                  <Text
                    fontSize={['13px', '14px', '14px', '18px', '18px']}
                    fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayRegular'}
                    fontWeight="400"
                    textAlign="center"
                  >
                    {subTitle}
                  </Text>
                  <Box
                    width={'100%'}
                    height={'100%'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    gap={[1, 1, 2, 5, 5]}
                    flexDirection={['column', 'column', 'column', 'row', 'row']}
                    padding={['0px 0px', '10px 0px', '10px 0px', '0px 0px', '0px 0px']}
                    paddingBottom={['10px', '10px', '10px', '0px', '0px']}
                  >
                    <NeroliOrchideeProductItem
                      activeLocale={activeLocale}
                      image={NeroliDisplayProduct1Image}
                      title={product1.title}
                      size={product1.size}
                      price={product1.price}
                      onClick={() => {
                        openProductPopUp('12MA030NO22', 'Loccitane', 'None');
                        setActive(false);
                      }}
                    />
                    <LoccitaneClose
                      boxSize={[6, 6, 8]}
                      cursor="pointer"
                      strokeWidth={0.5}
                      zIndex={30}
                      transform={'rotate(45deg)'}
                    />
                    <NeroliOrchideeProductItem
                      activeLocale={activeLocale}
                      image={NeroliDisplayProduct2Image}
                      title={product2.title}
                      size={product2.size}
                      price={product2.price}
                      onClick={() => {
                        openProductPopUp('11LC250NO23', 'Loccitane', 'None');
                        setActive(false);
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              width={['100%', '100%', '100%', '45%', '45%']}
              height={['100%', '100%', '100%', '100%', '100%']}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              padding={['0px', '0px', '0px', '25px', '25px 15px']}
              gap={['10px', '8px', '10px', '16px', '16px']}
            >
              <Image
                loading="lazy"
                width={['32px', '32px', '42px', '42px', '42px']}
                height={['30px', '30px', '40px', '40px', '40px']}
                objectFit="contain"
                src={NeroliOrchideeLogo}
                alt="Product Image"
              />
              <Text
                fontSize={['16px', '20px', '30px', '34px', '34px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
                fontWeight="500"
                textAlign="center"
                marginBottom={['0px', '0px', '10px', '10px', '10px']}
              >
                {title}
              </Text>
              <Text
                width={['90%', '80%', '60%', '100%', '100%']}
                fontSize={['13px', '13px', '13px', '17px', '17px']}
                fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayRegular'}
                fontWeight="400"
                textAlign="center"
                padding={['0px 10px', '0px 10px', '0px 0px', '0px 18px', '0px 20px']}
              >
                {text}
              </Text>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default NeroliOrchideeBestSellerModal;
